import React from 'react';
import PropTypes from 'prop-types';

import { Permissions } from '@src/global/permissions';

import Grid from '@mui/material/Grid';
import {
    BooleanInput,
    DateInput,
} from 'react-admin';
import { useWatch } from 'react-hook-form';

const AddToHomepageField = (props) => {
    const { source, resource } = props;
    const isHomeArticle = useWatch({ name: source.isHomeArticle });

    if (Permissions(resource, 'set_homepage') === false) {
        return null;
    }

    return (
        <>
            <Grid>
                <BooleanInput
                    label="Add to home page"
                    source={source.isHomeArticle}
                />
            </Grid>
            {isHomeArticle ? (
                <Grid>
                    <DateInput
                        label="Home Exp Date"
                        source={source.homepageExpiresAt}
                    />
                </Grid>
            ) : null}
        </>
    );
};

AddToHomepageField.propTypes = {
    resource: PropTypes.string,
    source: PropTypes.object,
};

export default AddToHomepageField;
